import { render } from "./ModalReportUser.vue?vue&type=template&id=5235c91a"
import script from "./ModalReportUser.vue?vue&type=script&lang=js"
export * from "./ModalReportUser.vue?vue&type=script&lang=js"

import "./ModalReportUser.vue?vue&type=style&index=0&id=5235c91a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/chat/parts/ModalReportUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5235c91a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5235c91a', __exports__)) {
    api.reload('5235c91a', __exports__)
  }
  
  module.hot.accept("./ModalReportUser.vue?vue&type=template&id=5235c91a", () => {
    api.rerender('5235c91a', render)
  })

}


export default __exports__